<template>
  <br/>
  <div class="card col-lg-6 container-fluid justify-content-center">
    <form @submit.prevent="updateChannel">
    <div class="card-body">
      <h4 class="text-center">Edit {{ channel.name ?? 'Name'}} channel</h4>
      <div class="accordion" id="accordionChannel">
        <div class="accordion-item">
          <h2 class="accordion-header"  id="headingChannelOne">
            <button class="accordion-button collapsed" :class="{'text-danger': validationChannelErrors.name || validationChannelErrors.slug}" type="button" data-bs-toggle="collapse" data-bs-target="#channelOne" aria-expanded="false" aria-controls="channelOne">
              General info
            </button>
          </h2>
          <div id="channelOne" class="accordion-collapse collapse" aria-labelledby="headingChannelOne" data-bs-parent="#accordionChannel">
            <div class="accordion-body">
                <div class="mb-3">
                  <label for="name" class="form-label">Name</label>
                  <input type="text" class="form-control" id="name" v-model="channel.name">
                  <p v-if="validationChannelErrors" v-for="names in validationChannelErrors.name" class="text-danger">{{ names}}</p>
                </div>
                <div class="mb-3">
                  <label for="slug" class="form-label">Slug</label>
                  <input type="text" class="form-control" id="slug" v-model="channel.slug">
                  <p v-if="validationChannelErrors" v-for="slugs in validationChannelErrors.slug" class="text-danger">{{ slugs}}</p>
                </div>
                <div class="mb-3">
                  <label for="category" class="form-label">Content category</label>
                  <select class="form-control" id="category" v-model="channel.category_id">
                    <option v-for="contentCategory in contentCategories" :key="contentCategory.id" :value="contentCategory.id">
                      {{ contentCategory.name }}
                    </option>
                  </select>
                  <div v-if="validationChannelErrors.category_id">
                    <p v-for="categoryError in validationChannelErrors.category_id" :key="categoryError" class="text-danger">{{ categoryError }}</p>
                  </div>
                  <p v-if="contentCategories.length === 0" class="text-muted small mb-0">No categories loaded</p>
                </div>
                <div class="mb-3">
                  <label for="country" class="form-label">Country</label>
                  <select class="form-control" id="country" v-model="channel.country">
                    <option v-for="country in countries" :key="country.value" :value="country.value">
                      {{ country.label ?? country.Label ?? country.value }}
                    </option>
                  </select>
                  <p v-if="validationChannelErrors" v-for="countryError in validationChannelErrors.country" class="text-danger">{{ countryError }}</p>
                </div>
                <div class="mb-3">
                  <label for="content_lang" class="form-label">Content language</label>
                  <select class="form-control" id="content_lang" v-model="channel.content_lang">
                    <option value="">Select content language</option>
                    <option v-for="(language, code) in contentLanguages" :key="code" :value="code">
                      {{ formatLanguageLabel(language) }}
                    </option>
                  </select>
                  <p v-if="validationChannelErrors" v-for="contentLangError in validationChannelErrors.content_lang" class="text-danger">{{ contentLangError }}</p>
                </div>
                <div class="mb-3">
                  <label for="tax_rule_id" class="form-label">Fee rules</label>
                  <select class="form-control" id="tax_rule_id" v-model="channel.tax_rule_id">
                    <option :value="null">None (use country / default rule)</option>
                    <option v-for="name in taxCategories" :value="name.id">
                      {{name.name}}
                    </option>
                  </select>
                  <p v-for="feeRuleError in validationChannelErrors.fee_rule_id" :key="feeRuleError" class="text-danger">{{ feeRuleError }}</p>
                  <div v-if="channel.effective_fee_rule" class="small mt-2">
                    <strong>Currently applied:</strong>
                    {{ taxSourceLabels[channel.effective_fee_rule.source] }} — {{ channel.effective_fee_rule.name }}
                    <span v-if="channel.effective_fee_rule.source === 'default'">
                      ({{ channel.effective_fee_rule.valid_from || 'always' }} → {{ channel.effective_fee_rule.valid_until || 'open-ended' }})
                    </span>
                    <div class="text-muted">
                      Micro {{ channel.effective_fee_rule.micro_percent }}% + {{ channel.effective_fee_rule.micro_fixed }},
                      regular {{ channel.effective_fee_rule.percent }}% + {{ channel.effective_fee_rule.fixed }},
                      VAT {{ channel.effective_fee_rule.vat_percent }}%
                    </div>
                    <div v-if="channel.effective_fee_rule.source === 'override'" class="text-warning">
                      A custom per-channel override takes priority over the selected rule.
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="status" class="form-label me-2 mt-2">Status</label>
                  <select id="status" class="form-control" v-model="channel.status">
                    <option value="awaiting_confirmation" :value="channel.status">Awaiting confirmation</option>
                    <option v-if="channel.country == 'UA'" value="ipay_confirmed_not_published" :value="channel.status">IPay confirmed not published</option>
                    <option v-else value="stripe_confirmed_not_published" :value="channel.status">Stripe confirmed not published</option>
                    <option value="pending_check" :value="channel.status">Pending check</option>
                    <option value="OK" :value="channel.status">OK</option>
                    <option value="denied" :value="channel.status">Denied</option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="adult" class="form-label">Adult</label>
                  <select class="form-control" id="adult" v-model="channel.adult">
                    <option value="true" :value="channel.adult">
                      Yes
                    </option>
                    <option value="false" :value="channel.adult">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="searchable" class="form-label">Searchable</label>
                  <select class="form-control" id="searchable" v-model="channel.searchable">
                    <option value="true" :value="channel.searchable">
                      Yes
                    </option>
                    <option value="false" :value="channel.searchable">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="frozen" class="form-label">Frozen</label>
                  <select class="form-control" id="frozen" v-model="channel.frozen">
                    <option value="true" :value="channel.frozen">
                      Yes
                    </option>
                    <option value="false" :value="channel.frozen">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="featured" class="form-label">Show creator in landing page</label>
                  <select class="form-control" id="featured" v-model="channel.featured">
                    <option value="1" :value="channel.featured">
                      Yes
                    </option>
                    <option value="0" :value="channel.featured">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="c-listed" class="form-label">Show creator in explore page</label>
                  <select class="form-control" id="c-listed" v-model="channel.c_listed">
                    <option value="true" :value="channel.c_listed">
                      Yes
                    </option>
                    <option value="false" :value="channel.c_listed">
                      No
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label for="business_type" class="form-label">Business type</label>
                  <input type="text" class="form-control" id="business_type" v-model="channel.business_type">
                  <p v-if="validationChannelErrors" v-for="business_type in validationChannelErrors.business_type" class="text-danger">{{ business_type}}</p>
                </div>
                <div class="mb-3">
                  <label for="mcc_type" class="form-label">MCC type</label>
                  <input type="text" class="form-control" id="mcc_type" v-model="channel.mcc_type">
                  <p v-if="validationChannelErrors" v-for="mcc_type in validationChannelErrors.mcc_type" class="text-danger">{{ mcc_type}}</p>
                </div>
            </div>
          </div>
        </div>
      </div>
      <br/>

      <div class="alert alert-success" role="alert" v-if="successChannel">
        {{ successChannel}}
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-dark-purple">Submit</button>
      </div>
    </div>
    </form>
  </div>
  <div class="card col-lg-6 container-fluid justify-content-center" id="ckeditor" v-if="channel.settings">
    <form @submit.prevent="updateChannelSettings" novalidate>
    <div class="card-body">
      <h4 class="text-center">Edit channel {{ channel.name ?? 'Name'}} settings</h4>
      <div class="accordion" id="accordionChannelSettings">
        <div class="accordion-item">
          <h2 class="accordion-header" id="channelSettingsHeadingsOne">
            <button class="accordion-button collapsed"   :class="{'text-danger': validationChannelSettingsErrors.twitch_url ||
              validationChannelSettingsErrors.youtube_url ||
              validationChannelSettingsErrors.twitch_url ||
              validationChannelSettingsErrors.github_url ||
              validationChannelSettingsErrors.instagram_url ||
              validationChannelSettingsErrors.tiktok_url ||
              validationChannelSettingsErrors.facebook_url}" type="button" data-bs-toggle="collapse" data-bs-target="#channelSettingsOne" aria-expanded="false" aria-controls="channelsSettingsOne">
              Social links
            </button>
          </h2>
          <div id="channelSettingsOne" class="accordion-collapse collapse" aria-labelledby="channelSettingsHeadingsOne" data-bs-parent="#accordionChannelSettings">
            <div class="accordion-body">
                <div class="mb-3">
                  <label for="instagram" class="form-label">Instagram URL</label>
                  <input type="text" class="form-control" id="instagram" v-model="channel.settings.instagram_url">
                  <p v-if="validationChannelSettingsErrors" v-for="instagram_url in validationChannelSettingsErrors.instagram_url" class="text-danger">{{ instagram_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="facebook" class="form-label">Facebook URL</label>
                  <input type="text" class="form-control" id="facebook" v-model="channel.settings.facebook_url">
                  <p v-if="validationChannelSettingsErrors" v-for="facebook_url in validationChannelSettingsErrors.facebook_url" class="text-danger">{{ facebook_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="twitter" class="form-label">Twitter URL</label>
                  <input type="text" class="form-control" id="twitter" v-model="channel.settings.twitter_url">
                  <p v-if="validationChannelSettingsErrors" v-for="twitter_url in validationChannelSettingsErrors.twitter_url" class="text-danger">{{ twitter_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="linkedin" class="form-label">LinkedIn URL</label>
                  <input type="text" class="form-control" id="linkedin" v-model="channel.settings.linkedin_url">
                  <p v-if="validationChannelSettingsErrors" v-for="linkedin_url in validationChannelSettingsErrors.linkedin_url" class="text-danger">{{ linkedin_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="youtube" class="form-label">Youtube URL</label>
                  <input type="text" class="form-control" id="youtube" v-model="channel.settings.youtube_url">
                  <p v-if="validationChannelSettingsErrors" v-for="youtube_url in validationChannelSettingsErrors.youtube_url" class="text-danger">{{ youtube_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="twitch" class="form-label">Twitch URL</label>
                  <input type="text" class="form-control" id="twitch" v-model="channel.settings.twitch_url">
                  <p v-if="validationChannelSettingsErrors" v-for="twitch_url in validationChannelSettingsErrors.twitch_url" class="text-danger">{{ twitch_url}}</p>
                </div>
                <h6 class="text-center"></h6>
                <div class="mb-3">
                  <label for="github" class="form-label">GitHub URL</label>
                  <input type="text" class="form-control" id="github" v-model="channel.settings.github_url">
                  <p v-if="validationChannelSettingsErrors" v-for="github_url in validationChannelSettingsErrors.github_url" class="text-danger">{{ github_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="tiktok" class="form-label">TikTok URL</label>
                  <input type="text" class="form-control" id="tiktok" v-model="channel.settings.tiktok_url">
                  <p v-if="validationChannelSettingsErrors" v-for="tiktok_url in validationChannelSettingsErrors.tiktok_url" class="text-danger">{{ tiktok_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="telegram" class="form-label">Telegram URL</label>
                  <input type="text" class="form-control" id="telegram" v-model="channel.settings.telegram_url">
                  <p v-if="validationChannelSettingsErrors" v-for="telegram_url in validationChannelSettingsErrors.telegram_url" class="text-danger">{{ telegram_url}}</p>
                </div>
                <div class="mb-3">
                  <label for="telegram" class="form-label">Discord URL</label>
                  <input type="text" class="form-control" id="telegram" v-model="channel.settings.discord_url">
                  <p v-if="validationChannelSettingsErrors" v-for="discord_url in validationChannelSettingsErrors.discord_url" class="text-danger">{{ discord_url}}</p>
                </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="channelSettingsHeadingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Privacy settings
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="channelSettingsHeadingTwo" data-bs-parent="#accordionChannelSettings">
            <div class="accordion-body">
              <div class="mb-3">
                <label for="public-earnings" class="form-label">Public earnings</label>
                <select class="form-control" id="public-earnings" v-model="channel.settings.public_earnings">
                  <option value="true" :value="channel.settings.public_earnings">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.public_earnings">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="public-subscribers" class="form-label">Public subscribers</label>
                <select class="form-control" id="public-subscribers" v-model="channel.settings.public_subscribers">
                  <option value="true" :value="channel.settings.public_subscribers">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.public_subscribers">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="enable-onetime" class="form-label">Enable onetime</label>
                <select class="form-control" id="enable-onetime" v-model="channel.settings.enable_onetime">
                  <option value="true" :value="channel.settings.enable_onetime">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.enable_onetime">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="auth-onetime" class="form-label">Auth onetime</label>
                <select class="form-control" id="auth-onetime" v-model="channel.settings.auth_onetime">
                  <option value="true" :value="channel.settings.auth_onetime">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.auth_onetime">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="chat-with-non-subscribers" class="form-label">Chat with non subscribers</label>
                <select class="form-control" id="chat-with-non-subscribers" v-model="channel.settings.chat_with_non_subscribers">
                  <option value="true" :value="channel.settings.chat_with_non_subscribers">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.chat_with_non_subscribers">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="one-timer-window-first" class="form-label">One timer window first</label>
                <select class="form-control" id="one-timer-window-first" v-model="channel.settings.onetimer_window_first">
                  <option value="true" :value="channel.settings.onetimer_window_first">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.onetimer_window_first">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="enable-one-timer-buttons" class="form-label">Enable one timer buttons</label>
                <select class="form-control" id="enable-one-timer-buttons" v-model="channel.settings.enable_onetimer_buttons">
                  <option value="true" :value="channel.settings.enable_onetimer_buttons">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.enable_onetimer_buttons">
                    No
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="channelSettingsHeadingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#channelSettingsThree" aria-expanded="false" aria-controls="channelSettingsThree">
              One timer settings
            </button>
          </h2>
          <div id="channelSettingsThree" class="accordion-collapse collapse" aria-labelledby="channelSettingsHeadingThree" data-bs-parent="#accordionChannelSettings">
            <div class="accordion-body">
              <div class="mb-3">
                <label for="onetimer-icon" class="form-label">One timer icon</label>
               <select class="form-control" id="onetimer-icon" v-model="channel.settings.onetime_icon">
                  <option style="color:black; width:80px; height:80px" id="fa-apple-alt" value="apple" :value="channel.settings.onetime_icon">
                     Apple
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-mug-hot" value="coffee" :value="channel.settings.onetime_icon">
                     Coffee
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-pizza-slice" value="donut" :value="channel.settings.onetime_icon">
                    Donut
                  </option>
                  <option style="color:black; width:80px; height:80px"  id="fa-euro-sign" value="euro" :value="channel.settings.onetime_icon">
                     Euro
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-coins" value="coin" :value="channel.settings.onetime_icon">
                    Coin
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-microphone-alt" value="podcast" :value="channel.settings.onetime_icon">
                    Podcast
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-basketball-ball" value="basketball" :value="channel.settings.onetime_icon">
                    Basketball
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-futbol" value="football" :value="channel.settings.onetime_icon">
                    Football
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-cocktail" value="cocktail" :value="channel.settings.onetime_icon">
                    Cocktail
                  </option>
                  <option style="color:black; width:80px; height:80px" id="fa-bone" value="bone" :value="channel.settings.onetime_icon">
                    Bone
                  </option>
                  <option style="color:black; width:80px; height:80px"  id="fa-heart" value="heart" :value="channel.settings.onetime_icon">
                    Heart
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="first-tip-price" class="form-label">First tip price</label>
                <input type="number" min="5" class="form-control" id="first-tip-price" v-model="channel.settings.first_tip_price">
              </div>
              <div class="mb-3">
                <label for="second-tip-price" class="form-label">Second tip price</label>
                <input type="number" min="10" class="form-control" id="second-tip-price" v-model="channel.settings.second_tip_price">
              </div>
              <div class="mb-3">
                <label for="third-tip-price" class="form-label">Third tip price</label>
                <input type="number" min="20" class="form-control" id="third-tip-price" v-model="channel.settings.third_tip_price">
              </div>
              <div class="mb-3">
                <label for="post-one-timer-button" class="form-label">Post one timer button</label>
                <select class="form-control" id="post-one-timer-button" v-model="channel.settings.post_onetimer_button">
                  <option value="true" :value="channel.settings.post_onetimer_button">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.post_onetimer_button">
                    No
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header"  id="channelSettingsHeadingFour">
            <button class="accordion-button collapsed" :class="{'text-danger': validationChannelSettingsErrors.about_me ||
           validationChannelSettingsErrors.onetime_description ||
           validationChannelSettingsErrors.welcome_subscriber_message}" type="button" data-bs-toggle="collapse" data-bs-target="#channelSettingsFour" aria-expanded="false" aria-controls="channelSettingsFour">
              Description settings
            </button>
          </h2>
          <div id="channelSettingsFour" class="accordion-collapse collapse" aria-labelledby="channelSettingsHeadingFour" data-bs-parent="#accordionChannelSettings">
            <div class="accordion-body">
              <div class="mb-3">
                <label for="about-me" class="form-label">About me</label>
                <quill-editor id="edit" theme="snow" content-type="html" :content="channel.settings.about_me" v-model="channel.settings.about_me"></quill-editor>
                <p v-if="validationChannelSettingsErrors" v-for="about_me in validationChannelSettingsErrors.about_me" class="text-danger">{{ about_me}}</p>
              </div>
              <div class="mb-3">
                <label for="welcome-subscriber-message" class="form-label">Welcome subscriber message</label>
                <input type="text" class="form-control" id="welcome-subscriber-message" v-model="channel.settings.welcome_subscriber_message">
                <p v-if="validationChannelSettingsErrors" v-for="welcome_subscriber_message in validationChannelSettingsErrors.welcome_subscriber_message" class="text-danger">
                  {{ welcome_subscriber_message}}
                </p>
              </div>
              <div class="mb-3">
                <label for="onetime-description" class="form-label">One time description</label>
                <textarea rows="8" cols="8" class="form-control" id="onetime-description" v-model="channel.settings.onetime_description"></textarea>
                <p v-if="validationChannelSettingsErrors" v-for="onetime_description in validationChannelSettingsErrors.onetime_description" class="text-danger">{{ onetime_description}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="channelSettingsHeadingFive">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#channelSettingsFive" aria-expanded="false" aria-controls="channelSettingsFive">
              Other settings
            </button>
          </h2>
          <div id="channelSettingsFive" class="accordion-collapse collapse" aria-labelledby="channelSettingsHeadingFive" data-bs-parent="#accordionChannelSettings">
            <div class="accordion-body">
              <div class="mb-3">
                <label for="plyr" class="form-label">Use Contribee player</label>
                <select class="form-control" id="plyr" v-model="channel.settings.plyr">
                  <option value="true" :value="channel.settings.plyr">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.plyr">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="rss-on" class="form-label">RSS links for audio posts</label>
                <select class="form-control" id="rss-on" v-model="channel.settings.rss_on">
                  <option value="true" :value="channel.settings.rss_on">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.rss_on">
                    No
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="copy-text" class="form-label">Copy text in posts</label>
                <select class="form-control" id="copy-text" v-model="channel.settings.copy_text">
                  <option value="true" :value="channel.settings.copy_text">
                    Yes
                  </option>
                  <option value="false" :value="channel.settings.copy_text">
                    No
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <br/>

        <div class="alert alert-success" role="alert" v-if="successChannelSettings">
        {{successChannelSettings}}
      </div>

        <div class="text-center">
          <button type="submit" class="btn btn-dark-purple">Submit</button>
        </div>
      </div>
    </div>
    </form>
  </div>
  <div class="card col-lg-6 container-fluid justify-content-center">
    <form @submit.prevent="changeChannelOwnership">
      <div class="card-body">
        <h4 class="text-center">Change {{ channel.name ?? 'Name'}} channel ownership</h4>
        <div class="accordion" id="accordionChannelChangeOwnership">
          <div class="accordion-item">
            <h2 class="accordion-header"  id="headingChannelChangeOwnership">
              <button class="accordion-button collapsed" :class="{'text-danger': validationChannelOwnershipErrors.email}" type="button" data-bs-toggle="collapse" data-bs-target="#channelChangeOwnership" aria-expanded="false" aria-controls="channelChangeOwnership">
                Change creator ownership
              </button>
            </h2>
            <div id="channelChangeOwnership" class="accordion-collapse collapse" aria-labelledby="headingChannelChangeOwnership" data-bs-parent="#accordionChannelChangeOwnership">
              <div class="accordion-body">
                <div class="mb-3">
                  <label for="user" class="form-label">User email</label>
                  <input class="form-control" id="user" v-model="channel.email"/>
                  <p v-if="validationChannelOwnershipErrors" v-for="emails in validationChannelOwnershipErrors.email" class="text-danger">{{ emails}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>

        <div class="alert alert-success" role="alert" v-if="successChannelChangeOwnerhsip">
          {{ successChannelChangeOwnerhsip}}
        </div>

        <div class="text-center">
          <button type="submit" class="btn btn-dark-purple">Submit</button>
        </div>
      </div>
    </form>
  </div>
  <div class="card col-lg-6 container-fluid justify-content-center">
    <form @submit.prevent="updateChannelUploadLimits">
      <div class="card-body">
        <h4 class="text-center">Change {{ channel.name ?? 'Name'}} creator upload limits (mb)</h4>
        <div class="input-group mb-3">
          <input id="upload-limits" type="number" min="500" v-model="channel.upload_limits" class="form-control" placeholder="500" aria-label="upload-limits" aria-describedby="basic-addon2">
          <span class="input-group-text" id="basic-addon2">MB</span>
        </div>
        <br/>
        <div class="alert alert-success" role="alert" v-if="successChannelUploadLimit">
          {{ successChannelUploadLimit}}
        </div>
        <div class="alert alert-danger" role="alert" v-if="errorChannelUploadLimit">
          {{ errorChannelUploadLimit}}
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-dark-purple">Submit</button>
        </div>
      </div>
    </form>
  </div>
  <div class="card col-lg-6 container-fluid justify-content-center">
    <form @submit.prevent="updateChannelProfileMerchantId">
      <div class="card-body">
        <h4 class="text-center">Change {{ channel.name ?? 'Name'}} IPay merchant Id</h4>
        <div class="input-group mb-3">
          <input id="upload-limits" type="string" v-model="channel.sub_merchant_id" class="form-control" aria-label="merchant_id" aria-describedby="basic-addon2">
          <span class="input-group-text" id="basic-addon2">Merchant Id</span>
        </div>
        <br/>
        <div class="alert alert-success" role="alert" v-if="successChannelMerchantId">
          {{ successChannelMerchantId}}
        </div>
        <div class="alert alert-danger" role="alert" v-if="errorChannelMerchantId">
          {{ errorChannelMerchantId}}
        </div>
        <div class="text-center">
          <button type="submit" class="btn btn-dark-purple">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@fortawesome/fontawesome-free/css/all.css';


export default {
  components: {FontAwesomeIcon, QuillEditor},
  data() {
    return {
      channel: {
        settings: {
          about_me: ''
        }
      },
      users: [],
      taxCategories: [],
      taxSourceLabels: {
        override: 'Custom override',
        personal: 'Personal rule',
        country: 'Country rule',
        default: 'Default rule',
        config: 'Config fallback',
      },
      resizeObserver: null,
      successChannel: '',
      successChannelSettings: '',
      successChannelChangeOwnerhsip: '',
      successChannelUploadLimit : '',
      successChannelMerchantId: '',
      contentCategories: [],
      countries: [],
      contentLanguages: {},
      validationChannelOwnershipErrors: [],
      validationChannelErrors: [],
      validationChannelSettingsErrors: [],
      errorChannelUploadLimit : '',
      errorChannelMerchantId: '',
    }
  },
  methods: {
    normalizeChannelCategoryId() {
      if (this.channel.category_id != null && this.channel.category_id !== '') {
        return;
      }
      if (this.channel.content_category_id != null) {
        this.channel.category_id = this.channel.content_category_id;
        return;
      }
      const categoryName = typeof this.channel.content_category === 'string'
          ? this.channel.content_category
          : null;
      if (categoryName && this.contentCategories.length) {
        const match = this.contentCategories.find(c => c.name === categoryName);
        if (match) {
          this.channel.category_id = match.id;
        }
      }
    },
    fetchChannel() {
      return axios.get(`admin/channels/${this.$route.params.id}`)
          .then(response => {
            this.channel = response.data;
            // Ensure settings is always an object, not null, and initialize all fields
            if (!this.channel.settings || this.channel.settings === null) {
              this.channel.settings = {};
            }
            // Initialize all social media fields if they don't exist
            const defaultSettings = {
              facebook_url: '',
              twitter_url: '',
              linkedin_url: '',
              youtube_url: '',
              twitch_url: '',
              github_url: '',
              instagram_url: '',
              tiktok_url: '',
              public_earnings: false,
              public_subscribers: false,
              enable_onetime: false,
              auth_onetime: false,
              chat_with_non_subscribers: false,
              onetimer_window_first: false,
              enable_onetimer_buttons: false,
              onetime_icon: '',
              first_tip_price: '',
              second_tip_price: '',
              third_tip_price: '',
              post_onetimer_button: false,
              about_me: '',
              welcome_subscriber_message: '',
              onetime_description: '',
              plyr: false,
              rss_on: false,
              copy_text: false
            };
            // Merge default settings with existing settings
            this.channel.settings = { ...defaultSettings, ...this.channel.settings };
          })
          .catch(error => {
            console.log(error);
          });
    },
    fetchContentCategories() {
      return axios.get('admin/content-categories', {
        params: { page: 1, per_page: 100, sort: 'position', direction: 'asc' },
      })
          .then(response => {
            const payload = response.data;
            if (Array.isArray(payload)) {
              this.contentCategories = payload;
            } else if (payload && Array.isArray(payload.data)) {
              this.contentCategories = payload.data;
            } else {
              this.contentCategories = [];
            }
          })
          .catch(error => {
            console.log(error);
            this.contentCategories = [];
          });
    },
    fetchTaxCategories() {
      return axios.get(`admin/fee-rules/list?type=2`)
          .then(response => {
            this.taxCategories = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },
    fetchCountries() {
      return axios.get('/admin/countries')
          .then(response => {
            this.countries = Array.isArray(response.data) ? response.data : [];
          })
          .catch(error => {
            console.log(error);
            this.countries = [];
          });
    },
    fetchContentLanguages() {
      return axios.get('/admin/languages')
          .then(response => {
            this.contentLanguages = response.data && typeof response.data === 'object'
                ? response.data
                : {};
          })
          .catch(error => {
            console.log(error);
            this.contentLanguages = {};
          });
    },
    formatLanguageLabel(language) {
      if (!language || typeof language !== 'object') {
        return '';
      }

      const native = language.native || language.name || '';
      return native.charAt(0).toUpperCase() + native.slice(1);
    },
    normalizeChannelContentLang() {
      if (this.channel.content_lang === null || this.channel.content_lang === undefined) {
        this.channel.content_lang = '';
      }
    },
    updateChannel() {
      this.validationChannelErrors = [];
      const payload = { ...this.channel };
      delete payload.content_category;
      delete payload.effective_fee_rule;
      payload.fee_rule_id = payload.tax_rule_id ?? null; // API still returns legacy tax_rule_id but expects fee_rule_id
      delete payload.tax_rule_id;

      axios.put(`admin/channels/${this.$route.params.id}`, payload)
          .then(response => {
            this.successChannel = response.data.message;
            this.refreshEffectiveTax();
            setTimeout(() => this.successChannel = '', 30000);
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationChannelErrors = error.response.data.errors;
            }
          });
    },
    refreshEffectiveTax() {
      return axios.get(`admin/channels/${this.$route.params.id}`)
          .then(response => {
            this.channel.effective_fee_rule = response.data.effective_fee_rule;
          })
          .catch(error => console.log(error));
    },
    changeChannelOwnership() {
      this.validationChannelOwnershipErrors = [];
      axios.put(`admin/change-ownership/${this.$route.params.id}`, {
        'email': this.channel.email
      })
          .then(response => {
            this.successChannelChangeOwnerhsip = response.data.success;
            setTimeout(() => this.successChannelChangeOwnerhsip = '', 30000);
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationChannelOwnershipErrors = error.response.data.errors;
            }
          });
    },
    updateChannelSettings() {
      this.validationChannelSettingsErrors = [];
      axios.put(`admin/channels/settings/${this.$route.params.id}`, this.channel.settings)
          .then(response => {
            this.successChannelSettings = response.data.message;
            setTimeout(() => this.successChannelSettings = '', 30000);
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.validationChannelSettingsErrors = error.response.data.errors;
            }
          });
    },
    updateChannelUploadLimits() {
      axios.put(`admin/channels/upload/limit/${this.$route.params.id}`, { upload_limits : this.channel.upload_limits })
      .then(response => {
        this.successChannelUploadLimit = response.data.message;
      })
      .catch(error => {
        this.errorChannelUploadLimit = error;
      });
    },
    updateChannelProfileMerchantId() {
      axios.post(`admin/channels/update/profile/merchant-id/${this.$route.params.id}`, {
        'sub_merchant_id' : this.channel.sub_merchant_id
      })
      .then(response => {
        this.successChannelMerchantId = response.data.message;
      })
      .catch(error => {
        this.errorChannelMerchantId = error.response.data.message;
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    Promise.all([
      this.fetchChannel(),
      this.fetchContentCategories(),
      this.fetchTaxCategories(),
      this.fetchCountries(),
      this.fetchContentLanguages(),
    ]).then(() => {
      this.normalizeChannelCategoryId();
      this.normalizeChannelContentLang();
    });
  }
}
</script>
